module.exports = __webpack_public_path__ + "img/tree_solution_package_application_2.28246ab9.png";